var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product != null
    ? _c(
        "b-row",
        { attrs: { "aling-h": "center" } },
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: { "label-cols-sm": "12", "label-cols-lg": "3" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.product.Name) +
                      ",\n            "
                  ),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.formatDuration(_vm.contract, _vm.priceList))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-lg": "3",
                    "content-cols": "6",
                    "content-cols-lg": "3"
                  }
                },
                [
                  _vm.product.Icon
                    ? _c("div", { staticClass: "text-center product-image" }, [
                        _c("img", {
                          staticClass: "product-icon",
                          attrs: {
                            alt: _vm.product.Name,
                            src: "/Content/PKS/images/" + _vm.product.Icon
                          }
                        })
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c("price-list-display", {
                attrs: {
                  "price-list": _vm.priceList,
                  actions: false,
                  showVat: _vm.showPricesWithVat
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm.selectedConinueWithSameProductId != 0
    ? _c(
        "b-row",
        [
          _c("b-col", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("Jatketaan samalla tuotteella")) +
                "\n    "
            )
          ])
        ],
        1
      )
    : _c(
        "b-row",
        [
          _c("b-col", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("Tuotetta ei ole valittu")) +
                "\n    "
            )
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }